import React from "react";
import "./PinkSale.css";

const PinkSale = ({ pinkSaleUrl, isActive = true }) => {
    if (!isActive) return null;

    const handlePinkSaleRedirect = () => {
        if (pinkSaleUrl) {
            window.open(pinkSaleUrl, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div className="pinksale-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">
                        <div className="pinksale-card">
                            <div className="pinksale-content">
                                <h3 className="pinksale-title">
                                    Join Our Presale on PinkSale
                                </h3>
                                <p className="pinksale-description">
                                    Secure your tokens now through our official
                                    PinkSale presale. Don't miss this
                                    opportunity to be part of our project!
                                </p>
                                <div className="pinksale-actions">
                                    <button
                                        className="btn-pinksale primary"
                                        onClick={handlePinkSaleRedirect}
                                    >
                                        <span>Buy on PinkSale</span>
                                        <i className="fas fa-external-link-alt"></i>
                                    </button>
                                    <div className="pinksale-features">
                                        <div className="feature-item">
                                            <i className="fas fa-shield-alt"></i>
                                            <span>Secure & Verified</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="fas fa-clock"></i>
                                            <span>Limited Time</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PinkSale;
